import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import React from "react";

const ResultList = (props) => {
  let { results = [] } = props;

  if (results && !Array.isArray(results)) {
    results = [results];
  }

  if (!results || results.length === 0) {
    return null;
  }

  return (
    <Grid container spacing={3} component="ul" className="fr-raw-list">
      {results}
    </Grid>
  );
};

ResultList.propTypes = {
  results: PropTypes.arrayOf(PropTypes.shape()),
};

export default ResultList;
